/* The spirits page: search, category, country, style and price filters, sort, and a 30/60 ml toggle.
   Reads window.BACKBAR (generated from back-bar-spirits.csv by build_spirits.py). */
(() => {
  'use strict';
  const DATA = window.BACKBAR;
  if (!DATA || !document.getElementById('spList')) return;
  const ITEMS = DATA.items;
  const $ = id => document.getElementById(id);

  /* KILLIK and GinFinity rows: colour, bottle and where a click goes. Images and the shop's root URL
     come from the page (#spirits-config), so they work with Shopify's CDN. */
  const CFG = (() => { try { return JSON.parse($('spirits-config').textContent); } catch (err) { return {}; } })();
  const IMG = CFG.images || {}, HOME = CFG.home || '/';
  const rum = (img, handle, c, t) => [IMG[img], HOME + 'products/' + handle, c, t];
  const gin = (img, c) => [IMG[img], HOME + 'products/' + img.replace('gin-bottle-', 'ginfinity-'), c, '#f6eee3'];
  const BOTTLES = {
    'killik-silver': rum('bottle-killik-silver', 'killik-silver', '#2c3d5c', '#dbe3f0'),
    'killik-silver-overproof': rum('bottle-killik-silver-overproof', 'killik-silver-overproof', '#2b4c4f', '#d4ebe4'),
    'killik-gold': rum('bottle-killik-gold', 'killik-gold', '#5b3448', '#f1d6c4'),
    'killik-spiced': rum('bottle-killik-spiced-rum', 'killik-spiced-rum', '#8a3655', '#fcdbe5'),
    'killik-toasted-coconut-liqueur': rum('bottle-killik-toasted-coconut', 'killik-toasted-coconut', '#86aaa8', '#102627'),
    'killik-tiki-zest-triple-sec': rum('bottle-tiki-zest-triple-sec', 'tiki-zest-triple-sec', '#b5602f', '#fff0e2'),
    'ginfinity-pulp-fiction': gin('gin-bottle-pulp-fiction', '#995433'),
    'ginfinity-ninja-myrtle': gin('gin-bottle-ninja-myrtle', '#9c7943'),
    'ginfinity-triple-juniper': gin('gin-bottle-triple-juniper', '#423357'),
    'ginfinity-limelight': gin('gin-bottle-limelight', '#667c32'),
    'ginfinity-blush-hour': gin('gin-bottle-blush-hour', '#843551'),
  };
  const OWN_COLOUR = { KILLIK: '#5b3448', GinFinity: '#423357' };

  const CATS = ['Rum', 'Whisky', 'Bourbon', 'Tequila', 'Gin'];
  const PRICE_BANDS = [['u10', 'Under $10', n => n < 10], ['10', '$10 – $14', n => n >= 10 && n < 15], ['15', '$15 – $19', n => n >= 15 && n < 20], ['20', '$20 and over', n => n >= 20]];
  const TAGS = ['Aged / cask', 'White / unaged', 'Spiced', 'Overproof / cask strength', 'Agricole / cachaça', 'Liqueur / fruit', 'Peated', 'Genever / Old Tom'];

  const S = { q: '', cat: 'All', origin: '', tags: new Set(), price: new Set(), sort: 'featured', pour: 30 };

  /* ---------- controls ---------- */
  const catCount = c => ITEMS.filter(i => c === 'All' || i.cat === c).length;
  $('spCats').innerHTML = ['All', ...CATS].map(c => `<button type="button" role="tab" data-cat="${c}" aria-selected="${c === 'All'}">${c}<span>${catCount(c)}</span></button>`).join('');
  const countries = [...new Set(ITEMS.flatMap(i => i.countries))].sort((a, b) => a.localeCompare(b));
  const byCountry = c => ITEMS.filter(i => i.countries.includes(c)).length;
  $('spOrigin').innerHTML = '<option value="">All countries</option>' + countries.map(c => `<option value="${c}">${c} (${byCountry(c)})</option>`).join('');
  $('spPrice').innerHTML = PRICE_BANDS.map(([k, l]) => `<button type="button" data-price="${k}" aria-pressed="false">${l}</button>`).join('');
  $('spTags').innerHTML = TAGS.map(t => `<button type="button" data-tag="${t}" aria-pressed="false">${t}<span>${ITEMS.filter(i => i.tags.includes(t)).length}</span></button>`).join('');

  /* ---------- filtering ---------- */
  const ALIASES = { whiskey: 'whisky', scotch: 'scotland', usa: 'usa', america: 'usa', american: 'usa', aussie: 'australia', rhum: 'agricole' };
  const hay = i => (i.name + ' ' + i.origin + ' ' + i.countries.join(' ') + ' ' + i.tags.join(' ') + ' ' + i.cat + ' ' + i.group).toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '');
  const HAY = new Map(ITEMS.map(i => [i, hay(i)]));
  const words = q => q.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').split(/\s+/).filter(Boolean).map(w => ALIASES[w] || w);
  const bands = () => PRICE_BANDS.filter(([k]) => S.price.has(k));

  function match(i) {
    if (S.cat !== 'All' && i.cat !== S.cat) return false;
    if (S.origin && !i.countries.includes(S.origin)) return false;
    if (S.tags.size && ![...S.tags].every(t => i.tags.includes(t))) return false;
    if (S.price.size) { if (i.neat == null || !bands().some(([, , f]) => f(i.neat))) return false; }
    const w = words(S.q);
    if (w.length) { const h = HAY.get(i); if (!w.every(x => h.includes(x))) return false; }
    return true;
  }
  const price = i => (S.pour === 60 ? i.ml60 : i.neat);
  const cmp = {
    featured: (a, b) => (b.ours - a.ours) || (a.group === b.group ? a.name.localeCompare(b.name) : (a.group === 'KILLIK' ? -1 : 1)),
    az: (a, b) => a.name.localeCompare(b.name),
    low: (a, b) => (price(a) ?? 999) - (price(b) ?? 999) || a.name.localeCompare(b.name),
    high: (a, b) => (price(b) ?? -1) - (price(a) ?? -1) || a.name.localeCompare(b.name),
    origin: (a, b) => (a.countries[0] || '').localeCompare(b.countries[0] || '') || a.name.localeCompare(b.name),
  };
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- rendering ---------- */
  function row(i) {
    const p = price(i);
    const pr = p == null ? '<em>Ask</em>' : `$${p}<small>${S.pour} ml</small>`;
    const sty = i.tags.slice(0, 2).map(t => `<span>${esc(t)}</span>`).join('');
    const b = BOTTLES[i.id] && BOTTLES[i.id][0] ? BOTTLES[i.id] : null;
    const inner = `<span class="nm">${i.ours ? '<i class="sq"></i>' : ''}${esc(i.name)}</span><span class="og">${esc(i.origin)}</span><span class="sty">${sty}</span><span class="bs">${b ? `<img class="bt" src="${b[0]}" alt="" loading="lazy">` : ''}</span><span class="pr">${pr}</span>`;
    if (b) return `<a class="sp-row ours" href="${b[1]}" style="--c:${b[2]};--t:${b[3]}" aria-label="${esc(i.name)}, ${p == null ? 'ask for price' : '$' + p + ' for ' + S.pour + ' ml'}">${inner}</a>`;
    const style = i.ours ? ` style="--c:${OWN_COLOUR[i.group]}"` : '';
    return `<div class="sp-row"${style}>${inner}</div>`;
  }
  const heading = (t, n) => `<div class="sp-gh"><h2>${esc(t)}</h2><span class="mono">${n}</span></div>`;

  function render() {
    const list = ITEMS.filter(match).sort(cmp[S.sort]);
    let html = '';
    if (S.sort === 'featured') {
      const groups = [];
      const add = (title, fn) => { const g = list.filter(fn); if (g.length) groups.push([title, g]); };
      add('KILLIK', i => i.group === 'KILLIK');
      add('GinFinity', i => i.group === 'GinFinity');
      const others = list.filter(i => !i.ours);
      if (S.cat === 'All') CATS.forEach(c => { const g = others.filter(i => i.cat === c); if (g.length) groups.push([c === 'Whisky' ? 'Whisky' : c === 'Bourbon' ? 'Bourbon' : c === 'Tequila' ? 'Tequila' : c === 'Gin' ? 'More gin' : 'More rum', g]); });
      else if (others.length) groups.push([list.some(i => i.ours) ? `More ${S.cat.toLowerCase()}` : S.cat, others]);
      html = groups.map(([t, g]) => heading(t, g.length) + g.map(row).join('')).join('');
    } else html = list.map(row).join('');
    $('spList').innerHTML = html;
    $('spEmpty').hidden = list.length > 0;
    $('spCount').textContent = `${list.length} ${list.length === 1 ? 'spirit' : 'spirits'}`;
    const active = (S.origin ? 1 : 0) + S.tags.size + S.price.size;
    $('spFcount').textContent = active || '';
    $('spClear').hidden = !(active || S.q || S.cat !== 'All');
    observeRows();
  }

  /* ---------- events ---------- */
  let t;
  $('spQ').addEventListener('input', e => { clearTimeout(t); t = setTimeout(() => { S.q = e.target.value; render(); }, 120); });
  $('spCats').addEventListener('click', e => {
    const b = e.target.closest('[data-cat]'); if (!b) return;
    S.cat = b.dataset.cat;
    $('spCats').querySelectorAll('button').forEach(x => x.setAttribute('aria-selected', String(x === b)));
    render();
  });
  $('spSort').addEventListener('change', e => { S.sort = e.target.value; render(); });
  $('spOrigin').addEventListener('change', e => { S.origin = e.target.value; render(); });
  $('spFbtn').addEventListener('click', () => {
    const open = $('spFilters').hidden;
    $('spFilters').hidden = !open;
    $('spFbtn').setAttribute('aria-expanded', String(open));
  });
  const toggle = (set, key, btn) => { set.has(key) ? set.delete(key) : set.add(key); btn.setAttribute('aria-pressed', String(set.has(key))); render(); };
  $('spPrice').addEventListener('click', e => { const b = e.target.closest('[data-price]'); if (b) toggle(S.price, b.dataset.price, b); });
  $('spTags').addEventListener('click', e => { const b = e.target.closest('[data-tag]'); if (b) toggle(S.tags, b.dataset.tag, b); });
  document.querySelector('.sp-pour').addEventListener('click', e => {
    const b = e.target.closest('[data-pour]'); if (!b) return;
    S.pour = +b.dataset.pour;
    document.querySelectorAll('.sp-pour button').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
    render();
  });
  $('spClear').addEventListener('click', () => {
    Object.assign(S, { q: '', cat: 'All', origin: '' }); S.tags.clear(); S.price.clear();
    $('spQ').value = ''; $('spOrigin').value = '';
    $('spCats').querySelectorAll('button').forEach(x => x.setAttribute('aria-selected', String(x.dataset.cat === 'All')));
    document.querySelectorAll('#spPrice button, #spTags button').forEach(x => x.setAttribute('aria-pressed', 'false'));
    render();
  });

  /* on touch there is no hover: light up the coloured row nearest the middle of the screen */
  let queued = false;
  const touch = matchMedia('(hover: none)').matches;
  function lit() {
    queued = false;
    if (!touch) return;
    const mid = innerHeight / 2; let best = null, bd = innerHeight * 0.25;
    document.querySelectorAll('a.sp-row').forEach(r => {
      const b = r.getBoundingClientRect(), d = Math.abs(b.top + b.height / 2 - mid);
      if (d < bd) { bd = d; best = r; }
      r.classList.remove('in');
    });
    best?.classList.add('in');
  }
  function observeRows() { lit(); }
  addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(lit); } }, { passive: true });

  render();
})();
